module.exports = __webpack_public_path__ + "img/face-smile-upside-down.6c5d84cc.svg";